import React, { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";
import Footer from "../../components/footer";
import FooterButton from "../../components/footerButton";
import PickDate from "../../components/common/datePicker";
import WarningModal from "../../components/clearWarningModal";

const Item1 = ({ isOpen, setIsOpen }) => (
  <>
    <button
      className="btn btn_danger px-5"
      onClick={() => setIsOpen(true)}
      data-toggle="modal"
      data-target="#exampleModal"
    >
      <small>CLEAR</small>
    </button>
    <WarningModal setIsOpen={setIsOpen} isOpen={isOpen} />
  </>
);

const Item2 = ({ props, date, handleSubmit }) => {
  const handleReview = () => {
    props.history.push({
      pathname: `/hcp/patient/function_review_entry`,
      state: { date },
    });
  };

  return (
    <div>
      <button
        className="btn btn_outline_light px-3 mx-3"
        onClick={handleSubmit}
      >
        <small>SAVE FOR LATER</small>
      </button>
      <button onClick={handleReview} className="btn btn_light ml-3">
        <small className="mx-3">REVIEW</small>
      </button>
    </div>
  );
};

const CreateAssessmentNotes = (props) => {
  const [date, setDate] = useState(
    props.location.state ? props.location.state.date : null
  );
  const [isOpen, setIsOpen] = useState(false);

  const handleSubmit = () => {
  };

  return (
    <>
      <div className="container-fluid pt-12 pl-21 pb-12 pr-24 h-100 noScroll">
        <div className="card border-0 h-100">
          <div className="card-body mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="font-weight-lighter mb-0">
                HCP: CREATE Assessment Notes
              </h5>
              <div className="media align-items-center">
                <h6 className="mb-0">
                  <small>Assessment Date: </small>
                </h6>
                <div className="mb-4 ml-2">
                  <div className="icon-container position-relative">
                    <sup>
                      <FaInfoCircle />
                    </sup>

                    <div className="overlay shadow rounded w-236">
                      <div
                        className="my-2 pl-2"
                        style={{ width: "100%", height: "100%" }}
                      >
                        <p>
                          The Assessment Date is the date that you SAW or
                          ASSESSED the patient. It is not always the date that
                          you enter the data.
                        </p>
                        <p>
                          eg. <br />
                          if you saw the patient on 10 Jan 2022 and you are
                          entering the data on 10 Jan 2022, select 10 Jan 2022
                          as the ASSESSMENT DATE.
                        </p>
                        <p>
                          if you saw the patient on 10 Jan 2022 and you are
                          entering the data on 12 Jan 2022, select 10 Jan 2022
                          as the ASSESSMENT DATE.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="media-body ml-2 w-186">
                  <PickDate date={date} setDate={setDate} />
                </div>
              </div>
            </div>
            <hr />
            {date && (
              <div className="noScroll h-90 verticalScroll border overlay-rounded py-4 px-2">
                <div className="mb-3">
                  <p className="small-text">
                    S: <span>Subject</span>
                  </p>
                  <div className="px-3">
                    <textarea
                      name=""
                      id=""
                      placeholder="Please enter notes here ..."
                      className="w-100 form-control outline-none"
                    ></textarea>
                  </div>
                </div>
                <div className="mb-3">
                  <p className="small-text">
                    O: <span>Objective</span>
                  </p>
                  <div className="px-3">
                    <textarea
                      name=""
                      id=""
                      placeholder="Please enter notes here ..."
                      className="w-100 form-control outline-none"
                    ></textarea>
                  </div>
                </div>
                <div className="mb-3">
                  <p className="small-text">
                    A: <span>Assessment</span>
                  </p>
                  <div className="px-3">
                    <textarea
                      name=""
                      id=""
                      placeholder="Please enter notes here ..."
                      className="w-100 form-control outline-none"
                    ></textarea>
                  </div>
                </div>
                <div>
                  <p className="small-text">
                    P: <span>Plan</span>
                  </p>
                  <div className="px-3">
                    <textarea
                      name=""
                      id=""
                      placeholder="Please enter notes here ..."
                      className="w-100 form-control outline-none"
                    ></textarea>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {date ? (
        <FooterButton
          child1={<Item1 setIsOpen={setIsOpen} isOpen={isOpen} />}
          child2={
            <Item2 props={props} date={date} handleSubmit={handleSubmit} />
          }
        />
      ) : (
        <Footer />
      )}
    </>
  );
};

export default CreateAssessmentNotes;
